// mixins
import directMobileCameraMixin from "../../src/mixins/mobile_wrapper/direct-mobile-camera-mixin"
import directDocumentScannerMixin from "../../src/mixins/mobile_wrapper/direct-document-scanner-mixin";

// utils
import { dynamicParameter } from "@/mixins/service/mixin-service";


const DEFAULT_CALLBACK = () => () => { };

export default function ({ storeFilesCallback = DEFAULT_CALLBACK, fileSubmitCallback = DEFAULT_CALLBACK, targetFieldPath, taskPayload }) {
    const getStoreFilesCallback = dynamicParameter(storeFilesCallback);
    const getFileSubmitCallback = dynamicParameter(fileSubmitCallback);
    const getTaskPayloadCallback = dynamicParameter(taskPayload);

    return {
        mixins: [
            directMobileCameraMixin(self => self.submitFile, targetFieldPath, self => getTaskPayloadCallback(self)),
            directDocumentScannerMixin(self => self.submitFile, targetFieldPath, self => getTaskPayloadCallback(self))
        ],
        methods: {
            handleCameraEvent() {
                return this.invokeCameraAction();
            },
            handleDocumentEvent(){
                return this.invokeDocumentScan();
            },
            async storeFiles(files, currentFiles) {
                if (!files) return;
                let errors = [];

                for (let file of [...files]) {
                    if (this.fileNotPresentNow(file, currentFiles)) {
                        try {
                            await this.submitFile(file);
                        }
                        catch (e) {
                            errors.push(e);
                        }
                    }
                }

                if (errors.length > 0) {
                    throw (errors);
                }

                getStoreFilesCallback(this)();
            },
            async submitFile(files) {
                try {
                    getFileSubmitCallback(this)(files);
                } catch (e) {
                    throw (e);
                }
            },
            fileNotPresentNow(possibleNewFile, currentFiles) {
                const byName = currentFile => currentFile.data.pathName === possibleNewFile.pathName;

                return !currentFiles.find(byName);
            },
        },
    }
}
